import { render, staticRenderFns } from "./sensor-list.vue?vue&type=template&id=87f62634&scoped=true"
import script from "./sensor-list.vue?vue&type=script&lang=js"
export * from "./sensor-list.vue?vue&type=script&lang=js"
import style0 from "./sensor-list.vue?vue&type=style&index=0&id=87f62634&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f62634",
  null
  
)

export default component.exports